// import { httpError } from "../utils";
import { config } from "./config";

export const httpClient = {
    get,
    put,
    post,
    callApi,
    postImage,
    deleteReq,
    handleResponse
};


function getHeaders() {
    let headers = {
        "Accept": "application/json"
    };
    return { headers };
}

function getRequestOption(credentials) {
    let headers = getHeaders(credentials).headers;
    let requestOptions = {
        credentials: "include",
        headers
    };

    if (!credentials) {
        delete requestOptions["credentials"];
    }

    return requestOptions;
}

function get(credentials = true) {
    let requestOptions = getRequestOption(credentials);

    requestOptions["method"] = "GET";
    return requestOptions;
}

function deleteReq(payload, credentials = true) {
    let requestOptions = getRequestOption(credentials);

    requestOptions["method"] = "DELETE";
    requestOptions["body"] = JSON.stringify(payload);
    return requestOptions;
}

function post(payload, credentials = true) {
    let requestOptions = getRequestOption(credentials);

    requestOptions["method"] = "POST";
    requestOptions["body"] = JSON.stringify(payload);
    return requestOptions;
}

function postImage(payload, credentials = true) {
    let requestOptions = getRequestOption(credentials);
    delete requestOptions.headers["Accept"];
    requestOptions.headers["Content-Type"] = "multipart/form-data";
    requestOptions["method"] = "POST";
    requestOptions["body"] = payload;
    return requestOptions;
}

function put(payload, credentials = true) {
    let requestOptions = getRequestOption(credentials);
    requestOptions["method"] = "PUT";
    requestOptions["body"] = JSON.stringify(payload);
    return requestOptions;
}

function callApi(
    method,
    endpoint,
    payload = {},
    credentials = true,
    image = false
) {
    let requestOptions = {};
    let url = config.apiUrl;
    
    switch (method) {
        case "GET":
            requestOptions = get(credentials);
            break;
        case "PUT":
            requestOptions = put(payload, credentials);
            break;
        case "POST":
            if (image) {
                requestOptions = postImage(payload, credentials);
            } else {
                requestOptions = post(payload, credentials);
            }
            break;
        case "DELETE":
            requestOptions = deleteReq(payload, credentials);
            break;
        default:
            console.log("Nothing here");
    }
    // console.log(`${url}${endpoint}`," :: url");
    // console.log(requestOptions, " :: options");
    return fetch(`${url}${endpoint}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    const { status } = response;
    let json = response.json();
    if (!(status === 200 || status === 201)) {
        // httpError.performAction(status);
        return json.then(res => {
            return Promise.reject(res);
        });
    }
    return json;
}